/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   import HostListItemData = com.vmware.vsphere.client.dvs.api.host.HostListItemData;
   export class DvsSelectHostsPageModel {
      hosts: HostListItemData[] = [];
   }
}